import { PRODUCT_QUERY_LIMIT } from "./constants";
import { ziplineFee, format } from "../OpportunitySidebar/helpers";

export function buildGetOwnedProductsVariables(searchText, lastRecord) {
  const variables = {
    name: {}
  };

  variables.name = {
    ...variables.name,
    contains: searchText,
    orderBy: "Ascending",
    ...(lastRecord && {
      cursor: lastRecord.name
    })
  };

  return {
    variables: {
      ...variables,
      ...(lastRecord && { cursor: lastRecord.id }),
      limit: PRODUCT_QUERY_LIMIT
    }
  };
}

export const isPriceValid = (price, fixedFee, variableFee) => {
  return price - ziplineFee(price, fixedFee, variableFee) > 0;
};

export function getMinimumPrice(fixedFee, variableFee) {
  return parseFloat(format(fixedFee / (1 - variableFee)));
}
